import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '~src/httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '~src/httpClient/serverApi/types/IGetItemsResult';
import { IUser } from '~src/userManagement/users/serverApi/types/IUser';

import { IProject } from '../types/IProject';

export interface IGetProjectsParams extends IGetItemsParams {
}

export interface IGetProjectsResult extends IGetItemsResult {
  projects?: IProject[];
  users?: IUser[];
  favorites?: string[];
}

export class GetProjectsRequest extends Request<IGetProjectsParams, IGetProjectsResult> {
  constructor(params: IGetProjectsParams) {
    super('getProjects', params);
  }
}
